// https://github.com/vercel/next.js/issues/37362
// this helps for cypress tests when the navigation between hashed is too fast
export const catchCancelledPush = (promise: Promise<boolean>) => {
  return promise.catch((error: { cancelled: boolean }) => {
    if (!error.cancelled) {
      throw error;
    }
  });
};
